module.exports = __webpack_public_path__ + "static/media/05_DSC0816.b65c664a.jpg";